import { predictiveCriterion } from '../../../../searchCriteria';

import { tokens } from '@cast/design-system';
import { QuickSearchFilter } from '@cast/shared-search-ui';

export const PredictiveQuickSearch = () => {
  return (
    <QuickSearchFilter
      chipSx={{
        ' svg': {
          color: tokens.theme.border.status.discovery,
        },
        '&:hover svg': {
          color: tokens.theme.border.status.discovery,
        },
        '&.quick-search-checked svg': {
          color: tokens.theme.border.status.discoverySubtle,
        },
      }}
      options={[
        {
          title: 'Predictable workload',
          value: 'true',
        },
      ]}
      criterion={predictiveCriterion}
      multiple
    />
  );
};
